import React from 'react';
import SelectSearch from 'react-select-search';
import { change } from 'redux-form';
import classNames from 'classnames';
import { connect } from 'react-redux';

const SelectSearchField = ({
  input,
  meta: { touched, error },
  options = [],
  label,
  placeholder,
  subLabel,
  formName,
  changeField,
  smallHeight,
}) => (
  <div
    className={classNames({
      'form-group': true,
      'has-error': touched && error,
      'has-success': touched && !error,
      'small-height': smallHeight,
    })}
  >
    {subLabel ? (
      <>
        <label className="m-0">{label}</label>
        <br />
        <span className={subLabel.className}>{subLabel.text}</span>
      </>
    ) : (
      <>
        <label className="control-label">{label}</label>
      </>
    )}
    <div
      className="relative"
      onKeyPress={(event) => {
        if (event.key === 'Enter') {
          event.stopPropagation();
          event.preventDefault();
        }
      }}
    >
      <SelectSearch
        options={options}
        search
        value={input.value}
        onChange={(value) => {
          changeField(formName, input.name, value);
        }}
        placeholder={placeholder}
        autoFocus={false}
        autoComplete={false}
      />
      <img
        className="select-search-caret"
        src="/images/icons/angle-down-solid.svg"
        alt=""
      />
    </div>
    {touched && error && <span className="help-block">{error}</span>}
  </div>
);

const mapStateToProps = null;
const mapDispatchToProps = {
  changeField: change,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectSearchField);
